// node_modules
import { FC, useCallback, useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
// Components
import { SquareTabContainer, TitledChild } from "Components";
import { FindDocuments } from "./FindDocuments/FindDocuments";
import { FindOrganizations } from "./FindOrganizations/FindOrganizations";
// styles
import styles from "./search.module.scss";
// Contexts
import { CaseContext } from "Stores";
import { FindAnswers } from "./FindAnswers";

export const Search: FC = () => {
    // Contexts
    const { caseState } = useContext(CaseContext);
    
    // Const
    // We get history to navigate
    const history = useHistory();

    // Define params and state
    const urlMatchedParams = useParams<{searchType?: string}>();
    const [selectedIndex, setSelectedIndex] = useState(0);

    // Logic
    const redirectToDefaultUrl = useCallback(() => {
        history.replace(`/cases/${caseState.selectedCaseId}/delivery/search/documents`);
    }, [caseState, history]);

    useEffect(() => {
        if(urlMatchedParams.searchType) {
            if(urlMatchedParams.searchType.toLowerCase() === "documents") {
                setSelectedIndex(0);
            } else if(urlMatchedParams.searchType.toLowerCase() === "organizations") {
                setSelectedIndex(1);
            } else if(urlMatchedParams.searchType.toLowerCase() === "questionanswering") {
                setSelectedIndex(2);
            }
            return;
        }        
        redirectToDefaultUrl();
    }, [urlMatchedParams.searchType, redirectToDefaultUrl]);

    const handleSearchSectionHasChanged = (index: number): void => {
        if(index === 0) {
            history.replace(`/cases/${caseState.selectedCaseId}/delivery/search/documents`);
        } else if(index === 1) {
            history.replace(`/cases/${caseState.selectedCaseId}/delivery/search/organizations`);
        } else if(index === 2) {
            history.replace(`/cases/${caseState.selectedCaseId}/delivery/search/questionanswering`);
        } else {
            redirectToDefaultUrl();
        }         
    };

    const getSearchContainerClassName = (): string => {
        const classNameList = [styles.searchContainer];
        return classNameList.join(" ");
    };

    return (  
        <div className={getSearchContainerClassName()}>
            <SquareTabContainer 
                parentallyIssuedSelectedTabIndex={selectedIndex} 
                setParentallyIssuedSelectedTabIndex={(index: number) => handleSearchSectionHasChanged(index)}
                extraClassNameTabContainer={styles.searchTypeTabContainer} 
                extraClassNameMainContainer={styles.searchSection}
                extraClassNameTabContentContainer={styles.searchSectionContentContainer}>
                <TitledChild title="Documents">
                    <FindDocuments />
                </TitledChild>
                <TitledChild title="Organizations">
                    <FindOrganizations />
                </TitledChild>
                <TitledChild title="Question answering">
                    <FindAnswers />
                </TitledChild>
            </SquareTabContainer>
        </div>
    );
};
